import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getlugar, postlugar } from "../../../redux/actions";
import styles from "./Lugares.module.css";

const Lugares = () => {
  const [lugar, setLugar] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const Lugar = useSelector((state) => state.lugar);

  useEffect(() => {
    dispatch(getlugar());
  }, [dispatch]);

  const handleCrearUbicacion = async () => {
    if (lugar.trim() === "") {
      setError("Debe ingresar un nombre de un lugar.");
      return;
    }

    try {
      await dispatch(postlugar(lugar));
      setLugar("");
      setError("");
      dispatch(getlugar()); // Refresca la lista después de crear

      Swal.fire({
        icon: "success",
        title: "Ubicación creada",
        text: "El lugar fue creado con éxito",
        confirmButtonColor: "#3559d1"
      });

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.error || "Ocurrió un error al crear el lugar"
      });
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Lugares</h2>

      <input
        type="text"
        placeholder="Escriba el nombre del lugar"
        value={lugar}
        onChange={(e) => setLugar(e.target.value)}
        className={styles.input}
      />

      {error && <p className={styles.error}>{error}</p>}

      <button onClick={handleCrearUbicacion} className={styles.boton}>
        Crear Lugar
      </button>

      <label className={styles.label}>Lugares registrados:</label>
      <select className={styles.select}>
        {Lugar?.length > 0 ? (
          Lugar.map((ubi) => (
            <option key={ubi.id} value={ubi.nombre}>
              {ubi.nombre}
            </option>
          ))
        ) : (
          <option disabled>No hay lugares registrado</option>
        )}
      </select>
    </div>
  );
};

export default Lugares;
